import ItemsV3Adapter from '@square/dashboard-items-data/adapters/items-v3-base';
export default class AgeRestriction extends ItemsV3Adapter {}